import React from 'react'
import {MdShoppingCart} from 'react-icons/md'
import Link from 'next/link'
import {useTranslation} from 'next-i18next'

import styles from './styles.module.css'

export default function NoProducts({parent}) {
  const {t} = useTranslation()
  const i18nWebsite = 'website:order.categoryPage.content.products'
  const i18nGeneric = 'generic:fields'

  return (
    <div className={styles.container}>
      <h2 className={styles.verticalMargin}>{t(`${i18nWebsite}.noProducts`)}</h2>
      <MdShoppingCart size="1.5em" className={styles.verticalMargin} />
      <h3>
        <Link
          href={parent ? `/pedir/category/${parent._id}` : '/'}
          prefetch={false}
          legacyBehavior>
          {t(`${i18nGeneric}.goBack`)}
        </Link>
      </h3>
    </div>
  );
}
